import React from "react";
import { Html, useProgress } from "@react-three/drei";
import InfinitySVG from "./InfinitySVG";

export function ProgressLoader()
{
    const { active, progress, errors, item, loaded, total } = useProgress();

    return (
        <>
            <Html center>
                <center><img src="https://cdn.discordapp.com/emojis/1028401125189230782.gif"></img></center>
                <InfinitySVG progress={Math.floor(progress)} />
            </Html>
        </>
    );
}
